import { withMetadata } from '../metadata'
import { searchNumbers as _searchNumbers } from '../../core/index'

export function searchNumbers() {
	return withMetadata(_searchNumbers, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/searchNumbers.js
// module id = ykZY
// module chunks = 0 1